<template>
  <div class="shareInfo"
       v-if="type && apiMap[type]">
    <div class="title">{{ detail ? detail[apiMap[type].title] : '' }}</div>
    <div class="time">
      <span>发布时间：{{ detail ? $moment(detail.createTime).format("YYYY.MM.DD") : '' }}</span>
      <span v-if="apiMap[type].incrApi">&nbsp;&nbsp;&nbsp;阅读量：{{ detail.originReadCount + detail.readCount }}</span>
    </div>
    <div v-if="apiMap[type].from" class="ifrom-wrap">
      <img src="/static/ifrom.png"
           alt="来源图标">
      <span class="ifrom">来源：{{ detail[apiMap[type].from] }}</span>
    </div>
    <div v-html="detail ? detail[apiMap[type].content] : ''"
         class="content"
         style="font-size: 16px"></div>

    <div class="downLoadApp">
      <img :src="appName == '高新企服通' ? '/static/share.png' : '/static/lpshare.png'"
           alt="下载"
           @click="download" />
    </div>
  </div>
</template>

<script src="http://res.wx.qq.com/open/js/jweixin-1.4.0.js"></script>

<script>

import { Toast } from 'mint-ui';
export default {
  name: "shareInfo",
  data() {
    return {
      code: "",
      type: "",
      detail: "",
      appName:'',
      // androidUrl:'https://download.zhengce001.com/linping1.1.3.apk',
      // IOSUrl:'https://apps.apple.com/cn/app/%E9%AB%98%E6%96%B0%E4%BC%81%E6%9C%8D%E9%80%9A/id1550906594',
      apiMap: {
        1: {
          url: "/policy/detail",
          method: "get",
          key: "policyId",
          title: "policyName",
          content: "policyContent",
          desc: "policySummary",
          img: "policyThumbnail",
          incrApi:"policy/incrReadCount",
          incrkey: "policyId",
          from: 'policyFrom',
        },
        2: {
          url: "/information/detail",
          method: "post",
          incrkey: "informId",
          title: "informName",
          content: "informContent",
          desc: "informSummary",
          img: "informThumbnail",
          incrApi:"information/incrReadCount",
          from: 'informFrom',
        },
        3: {
          url: "/information/detail",
          method: "post",
          incrkey: "informId",
          title: "informName",
          content: "informContent",
          desc: "informSummary",
          img: "informThumbnail",
          incrApi:"information/incrReadCount",
          from: 'informFrom',
        },
        4: {
          url: "/thirdService/detail",
          method: "post",
          incrkey: "thirdServiceId",
          title: "serviceName",
          content: "serviceContent",
          desc: "serviceSummary",
          img: "serviceThumbnail",
          incrApi:"thirdService/incrReadCount"
        },
        5: {
          url: "/newTownStyle/selectById",
          method: "get",
          title: "titleName",
          content: "describe",
          desc: "synopsis",
          img: "thumbnailUrl",
        }
      },
    };
  },
  async activated() {
    await this.getWxConfig();
    //获取数据
    const {
      query: { code, type,appName },
    } = this.$route;
    if (code && type) {
      this.type = type;
      this.code = code;
      this.appName=appName;
      this.getData();
    } else {
      // this.$router.push({ path: "/downLoad",query:{appName} });
    }
    this.incrReadCount();
  },
  watch: {
    $route: {
      handler: function (val, oldval) {
        const {
          query: { code, type,appName },
        } = this.$route;
        if (code && type) {
          this.type = type;
          this.code = code;
          this.appName=appName;
          this.getData();
        } else {
          this.$router.push({ path: "/downLoad",query:{appName} });
        }
      },
      deep: true,
    },
  },
  mounted(){
    setTimeout(() => {
        this.imageInit();
    }, 2000);
  },
  methods: {
    imageInit(){
        var imgList = [];
        var imgObjs = document.querySelectorAll(".content img") ;// 获取容器内所有的img元素
        for(var i=0; i<imgObjs.length; i++){// 遍历img元素
          let item= imgObjs[i];
          imgList.push(item.src||'');
          item.onclick = () => {
            wx.previewImage({
                current: item.src||'' ,  
                urls: imgList||[]     
            })
          };
        }
    },
    async getDownloadUrl(appType){
      const { appName }=this;
      if(!appName){
        window.location.href=appType==1?'https://download.zhengce001.com/linping1.1.3.apk':'https://apps.apple.com/cn/app/%E6%96%B0%E5%9F%8E%E4%BC%81%E6%9C%8D%E9%80%9A/id1518969288';
        return;
      }
      const res=await this.$ajax.post(`${process.env.baseURL}/appDetail/getAppDetailByName`,{appName,appType});
      const { code,data,msg }=res.data
      if(code==1 && data && data.appUrl){
        window.location.href=data.appUrl;
      } else{
        Toast('暂时无法下载');
      } 
      
    },
    //增加阅读量
    async incrReadCount(){
      const { apiMap,type,code}=this;
      if (apiMap[type].incrApi) {
        let params = {
          [apiMap[type].incrkey]:parseInt(code)
        }
        await this.$ajax.post(process.env.baseURL + [apiMap[type].incrApi]+`?${[apiMap[type].incrkey]}=${code}`,params);
      }
    },
    async getWxConfig() {
      const res = await this.$ajax.get(
        "https://lptownnewapi.zhengce001.com/wechat/jsconfig",
        { params: { url: window.location.href.split("#")[0] } }
      );
      //微信分享
      let wxConfig = res.data.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxConfig.appId, // 必填，公众号的唯一标识
        timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
        signature: wxConfig.signature, // 必填，签名
        jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
      });
    },
    //1.政策 2.通知 3.资讯 4.三方服务
    async getData() {
      const { type, code }=this;
      const { apiMap } = this;
      const res = await this.$ajax[apiMap[type].method](
        process.env.baseURL + apiMap[type].url,
        apiMap[type].method == "get"
          ? { params: { [apiMap[type].key || "id"]: code } }
          : { [apiMap[type].key || "id"]: code }
      );
      console.log(`${["政策", "通知", "资讯", "三方"][type - 1]}详情`, res);
      const { code: resCode, msg, data } = res.data;
      if (resCode == 1) {
        this.detail = data;
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: decodeURIComponent(data[apiMap[type].title]), // 分享标题
            desc: data[apiMap[type].desc], // 分享描述
            link: window.location.href.split("#")[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data[apiMap[type].img], // 分享图标
            success: function () {
              // 设置成功
            },
          });
          wx.updateTimelineShareData({
            title: decodeURIComponent(data[apiMap[type].title]), // 分享标题
            link: window.location.href.split("#")[0], // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: data[apiMap[type].img], // 分享图标
            success: function () {
              // 设置成功
            },
          });
        });
        wx.error(function(res){
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.log(res,99999)
        });
      }
    },
    getDeviceState() {
      var ua = navigator.userAgent.toLowerCase();
      var state = "default";
      if (ua.indexOf("android") > -1) {
        state = "android";
      } else if (ua.indexOf("xiaomi") > -1) {
        state = "xiaomi";
      } else if (ua.indexOf("iphone") > -1) {
        state = "iphone";
      } else if (ua.indexOf("ipad") > -1) {
        state = "ipad";
      }
      return state;
    },
    download() {
      debugger;
      const state = this.getDeviceState();
      switch (state) {
        case "iphone":
          this.getDownloadUrl(2);
          break;
        case "ipad":
          this.getDownloadUrl(2);
          break;
        default:
          this.getDownloadUrl(1);
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.shareInfo {
  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
  }

  height: 100%;
  width: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
  padding-bottom: 120px;

  .title {
    font-size: 38px;
    color: #1a1a1a;
    text-align: left;
    font-weight: bold;
    word-break: break-all;
    line-height: 51px;
  }

  .time {
    font-size: 26px;
    color: #999999;
    text-align: left;
    margin-top: 10px;
  }

  .content {
    width: 100%;
    margin-top: 40px;
    word-break: break-all;
    padding-bottom: 150px;

    img {
      max-width: 100%;
    }
  }

  .downLoadApp {
    position: fixed;
    width: 100%;
    bottom: 0px;
    left: 0px;

    img {
      width: 100%;
      height: 120px;
    }
  }

  .ifrom-wrap {
    display: flex;
    align-items: center;
    margin-top: 16px;
    background: #f6f7f9;
    padding: 16px;

    img {
      width: 34px;
      height: 34px;
    }

    .ifrom {
      margin-left: 20px;
      font-size: 26px;
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shareInfo.vue